module.exports = __webpack_public_path__ + "assets/img/1_1689_big.ab54429f.jpg";